module.exports = __webpack_public_path__ + "img/guide-ko-3.71ea13e9.png";